// types
import { IFormFieldTypes, IFormFieldRow } from '@/types/form';
// validations
import validations from '@/validations';
const { email, required, composeValidators } = validations;

export const FORM_FIELDS = [
  {
    fields: [
      {
        name: 'emailInput',
        placeholder: 'Enter email',
        fieldType: IFormFieldTypes.LANDING_PAGE_INPUT,
        widthRatio: 1,
        validate: composeValidators(required, email),
      },
    ],
  },
] as IFormFieldRow[];